import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
	Button,
	Card,
	Grid,
	IconButton,
	List,
	ListItem,
	ListItemIcon,
	ListItemSecondaryAction,
	ListItemText,
	Menu,
	MenuItem,
	TextField,
	Typography,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import {
	GetMenuItemDocument,
	useDeleteMenuItemMutation,
	useGetMenuItemQuery,
	useGetOutletQuery,
	useUpdateStatusMenuItemMutation,
	useIsMenuItemUsedQuery,
} from 'generated/graphql';
import { useMenuOption } from 'helpers/hooks/useMenuOption';
import { useFuseSearch } from 'helpers/hooks/useSearch';
import { SystemMsgs } from 'helpers/SystemMsg';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { NoImage } from '../../../../assets';
import { GeneralDeleteDialog } from '../../../../components/Dialog/GeneralDeleteDialog';
import './menuItemImage.scss';
import { CommonDialogV2 } from '@ifca-root/react-component/src/components/Dialog/CommonDialogV2';
import ShareIcon from '@material-ui/icons/Share';
// import DownloadIcon from '@mui/icons-material/Download';
import IconText from '@ifca-root/react-component/src/components/Typography/IconText';
import ExcelIcon from '../../../../assets/icons/excel.svg'
import { Controller } from 'react-hook-form';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import FileSaver from 'file-saver'
import * as ExcelJs from 'exceljs'
import {useExcelUploadVersion2} from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2'
import { DynamicFooter } from 'components/Footer/DynamicFooter';
import {ExcelInput} from '@ifca-root/react-component/src/components/Input/ExcelInput'
import { useLazyQuery } from '@apollo/react-hooks/lib/useLazyQuery';
import { GET_CURRENCY } from 'containers/AccountModule/AccountQuery';
import { AccountClient } from 'ProductsClient';
import { number } from 'yup';

export const MenuItemList = (props: any) => {
	const { outletID } = useParams<any>();

	const history = useHistory();
	const { anchorEl, menu, handleClick, handleClose } = useMenuOption();
	const [openDeleteDialog, setDeleteDialog] = useState(false);

	const [openStatusDialog, setOpenStatusDialog] = useState(false);

	const [rerender, setRender] = useState(false);
	const [openDialog,setOpenDialog] =useState(false);
	const menuItemSearch = JSON.parse(localStorage.getItem('searchFilter'));

	const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    setOpenSnackBar,
    snackBarMessage,
    currentData,
    setCurrentData,
    onDownloadTemplate,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
    setSnackBarMessage,
  } = useExcelUploadVersion2()
	const {
		data: { getMenuItem } = { getMenuItem: [] },
		loading: menuItemLoading,
	} = useGetMenuItemQuery({
		fetchPolicy: 'network-only',
		variables: {
			isSetMenu: false,
			outletID: outletID,
			orderByAsc: 'name',
		},
	});


		const {
		data: { isMenuItemUsed } = { isMenuItemUsed: false },
		loading: isMenuItemUsedLoading,
	} = useIsMenuItemUsedQuery({
		fetchPolicy: 'network-only',
		variables: {
			outletID: outletID,
			menuItemID: menu?.ID
		},
	});
	const {
		called: ouletCalled,
		loading: outletLoading,
		error: outletError,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});

	const [
			loadCurrency,
			{
				loading: currencyLoading,
				error: currencyError,
				data: { getCurrency } = { getCurrency: [] },
			},
		] = useLazyQuery(GET_CURRENCY, {
			client: AccountClient,
		});

	const outletArray: any[] = getOutlet;

	const [
		deleteMenuItem,
		{ loading: deleteMenuItemLoading },
	] = useDeleteMenuItemMutation({
		onError: error => {
			console.log('ERROR', error);
			if (error.message.includes('FK_')) {
				setOpenSnackBar(true);
				setSnackBarMessage(SystemMsgs.deleteRecordInUse());
			}
		},
		onCompleted: data => {
			setOpenSnackBar(true);
			setSnackBarMessage(SystemMsgs.deleteRecord());
		},
	});

	const [
		updateStatusMenuItem,
		{ loading: updateStatusMenuItemLoading },
	] = useUpdateStatusMenuItemMutation({
		onCompleted: data => {
			setOpenSnackBar(true);
			setSnackBarMsg(SystemMsgs.updateRecord());
		},
	});

	const submitUpdateStatusMenuItem = () => {
		updateStatusMenuItem({
			variables: {
				status: menu?.obj?.isActive === true ? false : true,
				outletID: outletID,
				menuItemID: menu?.ID,
			},
			refetchQueries: [
				{
					query: GetMenuItemDocument,
					variables: {
						isSetMenu: false,
						outletID: outletID,
						orderByAsc: 'name',
					},
				},
			],
		});
	};

	const { filteredList, handleSearch, setOriginalListing } = useFuseSearch();

	useEffect(() => {
		if (getMenuItem && getMenuItem?.length > 0) {
			setOriginalListing(getMenuItem);
		}
	}, [getMenuItem]);

	// const { setOpenSnackBar, setSnackBarMsg } :any = useContext(
	// 	SnackBarContext as any,
	// );

	useEffect(() => {
		if (
			!menuItemLoading &&
			!!menuItemSearch?.menuItemSearch &&
			getMenuItem?.length > 0
		) {
			handleSearch(`'"${menuItemSearch?.menuItemSearch ?? ''}"`, ['name']);
			setRender(true);
		}
	}, [menuItemLoading, rerender, getMenuItem]);

	return (
		<>
			{menuItemLoading && <Loading />}
			{outletLoading && <Loading />}
			{deleteMenuItemLoading && <Loading />}

			<MainHeader
				onClick={() => {
					localStorage.setItem(
						`searchFilter`,
						JSON.stringify({
							outletList: menuItemSearch?.outletList ?? '',
							outletSubmenu: menuItemSearch?.outletSubmenu ?? '',
							menuItemSearch: '',
						}),
					);
					history.push({
						pathname: `/menu/outlet-app/outlet-setting/${outletID}`,
					});
				}}
				mainBtn="close"
				smTitle={`Outlet App`}
				title={outletArray[0]?.name}
				routeSegments={[
					{ name: 'Outlet Settings' },
					{ name: 'Menu Items', current: true },
				]}
			/>

			<SearchHeader
				title="Menu Items"
				value={`${filteredList?.length ?? 0}`}
				onChangeAction={e => {
					handleSearch(`'"${e?.target?.value}"`, ['name']);
					localStorage.setItem(
						`searchFilter`,
						JSON.stringify({
							outletList: menuItemSearch?.outletList ?? '',
							outletSubmenu: menuItemSearch?.outletSubmenu ?? '',
							menuItemSearch: e?.target?.value,
						}),
					);
				}}
				fixed
				isDefaultValue={!!menuItemSearch?.menuItemSearch ?? false}
				defaultValue={menuItemSearch?.menuItemSearch ?? ''}
				search
				onCloseAction={() => {
					localStorage.setItem(
						`searchFilter`,
						JSON.stringify({
							outletList: menuItemSearch?.outletList ?? '',
							outletSubmenu: menuItemSearch?.outletSubmenu ?? '',
							menuItemSearch: '',
						}),
					);
					handleSearch('', []);
				}}
				clickText
			/>
			<ContentWrapper float search>
			<div className="message-alert text-noflow">
            <div className="flex-space">
              {/* <IconText
                icon={
                  <img
                    src={ExcelIcon}
                    style={{ width: '19px', paddingRight: '5px' }}
                  />
                }
                font="mdDesc"
                children={
                  <>
                    <span style={{ fontWeight: 'bold' }}>Download </span>{' '}
                    <span>Excel Template</span>
                  </>
                }
              ></IconText> */}
				<div className="icon-text">
					<img
						src={ExcelIcon}
						style={{ width: '19px', paddingRight: '5px' }}
					/>
					<span className='mdDesc'>
						<span style={{fontWeight:'bold'}}>Download</span>{' '}
						<span>Excel Template</span>
					</span>
				</div>
			</div>
            <div>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{
                  minWidth: '0px',
                  width: '32px',
                  height: '24px',
                  margin: '-2px 0px -2px 0px',
                }}
                onClick={() => {
                  setOpenDialog(true)
                }}
              >
                <ShareIcon
                  style={{
                    width: '17px',
                    height: '17px',
                  }}
                />
              </Button>
            </div>
          </div>
				<List className="core-list">
					{!menuItemLoading &&
					!outletLoading &&
					(getMenuItem === undefined || getMenuItem?.length === 0) ? (
						<EmptyList
							title="No Record found"
							subtitle="Add a new record now."
						/>
					) : (
						filteredList?.map((el, index) => (
							<ListItem disabled={el?.isActive === false}>
								{/* <div style={{ paddingRight: '6px' }}>
									<img
										src={el?.attachments?.fileURL}
										className="img-owned"
										loading="lazy"
									/>
								</div> */}

								<ListItemIcon>
									{el?.attachments?.fileURL ? (
										<img className="img-owned" src={el?.attachments?.fileURL} />
									) : (
										<img
											className="img-owned"
											style={{
												border: 'none',
											}}
											src={NoImage}
										/>
									)}
								</ListItemIcon>
								<ListItemText
									primary={
										<>
											<span className="xsTitle flex-space">{el?.name}</span>
											<span className="xxTitle highlight-text text-separator"></span>

											<span className="xxTitle highlight-text text-separator">
												{el.isActive ? (
													<Grid
														component={Card}
														style={{
															background: '#ff9800',
															padding: '.2rem .5rem .2rem .5rem ',
															boxShadow: 'none',
														}}
													>
														<Typography
															variant="caption"
															style={{
																fontSize: '10px',
																color: 'white',
															}}
														>
															Active
														</Typography>
													</Grid>
												) : null}
											</span>
										</>
									}
									secondary={
										<>
											<span className="desc">
												<span className="mdDesc fw-medium">
													{el?.nativeName}
													<br></br>
												</span>
												<span className="desc">{el?.description}</span>
											</span>
										</>
									}
								/>

								<ListItemSecondaryAction>
									<IconButton
										edge="end"
										aria-label="more"
										aria-controls="menu-list"
										aria-haspopup="true"
										onClick={e => handleClick(e, el.ID, index, el)}
									>
										<MoreVert />
									</IconButton>
								</ListItemSecondaryAction>
							</ListItem>
						))
					)}
				</List>
				<Menu
					id="menu-list"
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleClose}
					onClick={handleClose}
				>
					<MenuItem
						onClick={() =>
							history.push({
								pathname: `/menu/outlet-app/outlet-setting/${outletID}/menu-item/${menu?.ID}/edit`,
								state: {
									menuItem: menu?.obj,
									menuOptionItem: menu?.obj?.menuItemOptions,
								},
							})
						}
					>
						<span className="">Edit</span>
					</MenuItem>

					<MenuItem
						onClick={() => {
							setOpenStatusDialog(true);
						}}
					>
						<span className="">
							{menu?.obj?.isActive === true ? `Inactive` : `Active`}
						</span>
					</MenuItem>

					<MenuItem
					onClick={() => {
						setDeleteDialog(true);
					}}
					disabled={isMenuItemUsed === true || isMenuItemUsedLoading === true}
				>
					<span>Delete</span>
				</MenuItem>
				</Menu>
			</ContentWrapper>

			<GeneralDeleteDialog
				ID={menu?.ID}
				refetchID={{ outletID: outletID, isSetMenu: false, orderByAsc: 'name' }}
				openDialog={openDeleteDialog}
				setOpenDialog={setDeleteDialog}
				dialogName={menu?.obj?.name}
				deleteMutation={deleteMenuItem}
				refetchDocument={GetMenuItemDocument}
			/>
			<ExcelInput
				showFooter={false}
				showDupErrors={true}
				duplicateItems={duplicateItems}
				errorDia={duplicateErrorDia}
				setErrorDia={setErrorDialog}
				openUpload={openDialog}
				setOpenUpload={setOpenDialog}
				upload={fileTitle}
				template={currentData}
				setTemplate={setCurrentData}
				setUpload={setFileTitle}
				resetFileUpload={resetFileUpload}
				onUploadTemplate={() => {
				const normalize = name => name?.toLowerCase().replace(/\s+/g, "").trim();
				const exceldata = [
					{
						menuitemlist:[],
						testing:[]
					}
				];
				const sheetvalidation = (sheetName,targetkey,mapping)=>{
						const sheet = currentData.find(
							s=>normalize(s.sheetName)=== normalize(sheetName)
						);

						if (!sheet) {
							console.warn(`Sheet ${sheetName} not found`);
							return ;
						}

						exceldata[0][targetkey].push({
							sheetName:sheetName,
							rows:sheet.rows.map(mapping),
						})
					}
				// const menuSheet = currentData.find(
				// 	s =>normalize(s.sheetName) === normalize("MenuItemList")
				// );
				// if (!menuSheet) {
				// 	console.error("MenuItemList sheet not found:", currentData);
				// 	return;
				// }

				console.log('currentData',currentData);
				

				// const digitalmenuSheet = currentData.find(
				// 	s => s.sheetName?.trim().toLowerCase() === "digitalmenu"
				// );
				// console.log('currentdata',currentData);
				
				// if (!digitalmenuSheet) {
				// 	console.error("DigitalMenu sheet not found:", currentData);
				// 	return;
				// }
				// const Testingsheet = currentData.find(
				// 	s =>normalize( s.sheetName) === normalize("testing")
				// );

				// if (!Testingsheet) {
				// 	console.error("Testing sheet not found:", Testingsheet);
				// 	return;
				// }

				sheetvalidation("MenuItemList","menuitemlist",x=>({
					sheetName:"MenuItemList",

					name: x?.name === null ? null:`${x?.name?.trim()}`,
					nativeName: x?.nativeName === null ? null:`${x?.nativeName?.trim()}`,
					kitchenName: x?.kitchenName === null? null:`${x?.kitchenName?.trim()}`,
					description: x?.description === null? null: `${x?.description?.trim()}`,
					major: x?.major === null ? null:`${x?.major?.trim()}`,
					family: x?.family === null ? null :`${x?.family?.trim()}` ,
					kitchenPrinter: x?.kitchenPrinter === null ? null :`${x?.kitchenPrinter?.trim()}`,
					taxschemes: x?.taxschemes === null ? null: `${x?.taxschemes?.trim()}`,
					uom: x?.uom === null? null :`${x?.uom?.trim()}`,
					defaultQuantity: x?.defaultQuantity === null ? null:Number(x?.defaultQuantity),
					isOpenItem: x?.isOpenItem === null?null:`${x?.isOpenItem}`,
					isOpenPrice: x?.isOpenPrice === null?null:`${x?.isOpenPrice}`,
					isChefRecommended: x?.isChefRecommended ===null?null:`${x?.isChefRecommended}`,
					isQuantityControlled: x?.isQuantityControlled === null?null:`${x?.isQuantityControlled}`,
					isDiscountable: x?.isDiscountable === null?null:`${x?.isDiscountable}`,
					isByWeight: x?.isByWeight===null?null:`${x?.isByWeight}`,
					standardCost: Number(x?.standardCost) === null?null: Number(x?.standardCost),
					isPerforated: x?.isPerforated ===null?null:`${x?.isPerforated}`,
					perforatedQuantity:
						x?.perforatedQuantity == null
							? null
							: Number(x?.perforatedQuantity)
				}));
				
				sheetvalidation("Testing","testing",x=>({
					sheetName:"Testing",
					testingname: x?.testingname === null ? null:`${x?.testingname?.trim()}`,
					testingemail: x?.testingemail=== null? null:`${x?.testingemail?.trim()}`,
				}));

				console.log("exceldata",exceldata);
				
				history.push({
					pathname: `/menu/outlet-app/outlet-setting/${outletID}/menu-item/excel-validation`,
					state: {
						excelData:exceldata,
						//  [
							// {
								// sheetName: "MenuItemList",
								// rows: menuSheet?.rows?.map(x => ({
								// 	name: x?.name?.trim() || null,
								// 	nativeName: x?.nativeName?.trim() || null,
								// 	kitchenName: x?.kitchenName?.trim() || null,
								// 	description: x?.description?.trim() || null,
								// 	major: x?.major?.trim() || null,
								// 	family: x?.family?.trim() || null,
								// 	kitchenPrinter: x?.kitchenPrinter?.trim() || null,
								// 	taxschemes: x?.taxschemes?.trim() || null,
								// 	uom: x?.uom?.trim() || null,
								// 	defaultQuantity: Number(x?.defaultQuantity) || 0,
								// 	isOpenItem: String(x?.isOpenItem).trim(),
								// 	isOpenPrice: String(x?.isOpenPrice).trim(),
								// 	isChefRecommended: String(x?.isChefRecommended).trim(),
								// 	isQuantityControlled: String(x?.isQuantityControlled).trim(),
								// 	isDiscountable: String(x?.isDiscountable).trim(),
								// 	isByWeight: String(x?.isByWeight).trim(),
								// 	standardCost: Number(x?.standardCost) || 0,
								// 	isPerforated: String(x?.isPerforated).trim(),
								// 	perforatedQuantity:
								// 		x?.perforatedQuantity == null
								// 			? null
								// 			: Number(x?.perforatedQuantity)
								// }))
								// sheetvalidation("MenuItemList",x=>({
								// 	name: x?.name?.trim() || null,
								// 	nativeName: x?.nativeName?.trim() || null,
								// 	kitchenName: x?.kitchenName?.trim() || null,
								// 	description: x?.description?.trim() || null,
								// 	major: x?.major?.trim() || null,
								// 	family: x?.family?.trim() || null,
								// 	kitchenPrinter: x?.kitchenPrinter?.trim() || null,
								// 	taxschemes: x?.taxschemes?.trim() || null,
								// 	uom: x?.uom?.trim() || null,
								// 	defaultQuantity: Number(x?.defaultQuantity) || 0,
								// 	isOpenItem: String(x?.isOpenItem).trim(),
								// 	isOpenPrice: String(x?.isOpenPrice).trim(),
								// 	isChefRecommended: String(x?.isChefRecommended).trim(),
								// 	isQuantityControlled: String(x?.isQuantityControlled).trim(),
								// 	isDiscountable: String(x?.isDiscountable).trim(),
								// 	isByWeight: String(x?.isByWeight).trim(),
								// 	standardCost: Number(x?.standardCost) || 0,
								// 	isPerforated: String(x?.isPerforated).trim(),
								// 	perforatedQuantity:
								// 		x?.perforatedQuantity == null
								// 			? null
								// 			: Number(x?.perforatedQuantity)
								// })),
								
								// sheetvalidation("Testing",x=>({
								// 	testingname: x?.testingname === null ? null:`${x?.testingname?.trim()}`,
								// 	testingemail: x?.testingemail=== null?null:`${x?.testingemail?.trim()}`,
								// }))
							// },
							// {
							// 	sheetName: "DigitalMenu",
							// 	rows: digitalmenuSheet.rows?.map(x => ({
							// 		outletName: x?.outletName?.trim() || null,
							// 		Name: x?.Name?.trim() || null,
							// 		Description: x?.Description?.trim() || null
							// 	}))
							// },
							// {
							// 	sheetName: "Testing",
							// 	rows: Testingsheet.rows?.map(x => ({
							// 		testingname: x?.testingname === null ? null:`${x?.testingname?.trim()}`,
							// 		testingemail: x?.testingemail=== null?null:`${x?.testingemail?.trim()}`,
							// 	}))
							// },
						// ]
						
						fileTitle
					}
				});

				setOpenFileUpload(false);
				}}

				onSelectFile={(e: any) => {
				onSelectFile({ event: e})
				}}
				downloadButton={true}
				onDownloadTemplate={() => {
				onDownloadTemplate({
					name: `Menu_Item_Template`,
					// workSheetName: `MenuItemList123`,
					sheet:[
					{
						sheetName:"MenuItemList",
						headerSetup:extJournalTemplateForm,
					},
					],
					// headerSetup: extJournalTemplateForm,
					isHeaderLocked: true,
					defaultHeaderFillStyle: {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'D3D3D3' },
					},
					defaultHeaderBorderStyle: {
					top: { style: 'thin' },
					left: { style: 'thin' },
					bottom: { style: 'thin' },
					right: { style: 'thin' },
					},
					listType: {
					hasCountry: true,
					hasNationality: true,
					},
					extraListData: [
					{
						data: getCurrency?.map(x => x?.code),
						worksheetName: 'BaseCurrency',
						dataType: 'BaseCurrency',
					},
					{
						data: [
						'No Tax',
						'GST Registration No.',
						'SST Registration No.',
						],
						worksheetName: 'companytax',
						dataType: 'companytax',
					},
					],
				})
				}}
				snackBarProps={{
				openSnackBar: openSnackBar,
				snackBarMessage: snackBarMessage,
				setOpenSnackBar: setOpenSnackBar,
				onClickButton: () => {
					setOpenSnackBar(false)
				},
				}}
      />
			{/* <CommonDialog
        		fullWidth={true}
				open={openDialog}
				onClose={() => {
				setOpenDialog(false)
				}}
				sections={{
				header: {
					dynamic: (
					<div className="">
						<div className="dialog-dynamic-content">
						<span
							className="title c-orange flex-space"
							style={{
							fontSize: '13px',
							fontWeight: 'bold',
							}}
						>
							Excel
						</span>

						<span
							className="title c-orange"
							style={{
							fontSize: '13px',
							fontWeight: 'bold',
							textAlign: 'right',
							}}
						>
							{'Download'}
						</span>
						</div>
					</div>
					),
				},
				body: () => (
					<div>
					<span>{'Are you sure to Download Excel?'}</span>
					</div>
				),

				footer: {
					actions: [
					{
						displayText:`${<img src={ExcelIcon} />}Download`,
						props: {
						onClick: () => {
							onDownloadTemplate({
							name: `External Journal Template`,
							workSheetName: `Journal List`,
							headerSetup: extJournalTemplateForm,
							isHeaderLocked: true,
							defaultHeaderFillStyle: {
								type: 'pattern',
								pattern: 'solid',
								fgColor: { argb: 'D3D3D3' },
							},
							defaultHeaderBorderStyle: {
								top: { style: 'thin' },
								left: { style: 'thin' },
								bottom: { style: 'thin' },
								right: { style: 'thin' },
							},
							listType: {
								hasCountry: true,
								hasNationality: true,
							},
							})
							setOpenDialog(false)
						},
						variant: 'contained',
						color: 'primary',
						},
					},
					{
						displayText: 'Cancel',
						props: {
						onClick: () => {
							setOpenDialog(false)
						},
						variant: 'contained',
						color: 'primary',
						},
					},
					{
						displayText: 'Upload',
						props: {
						onClick: () => {
							onDownloadTemplate({
							name: `External Journal Template`,
							workSheetName: `Journal List`,
							headerSetup: extJournalTemplateForm,
							isHeaderLocked: true,
							defaultHeaderFillStyle: {
								type: 'pattern',
								pattern: 'solid',
								fgColor: { argb: 'D3D3D3' },
							},
							defaultHeaderBorderStyle: {
								top: { style: 'thin' },
								left: { style: 'thin' },
								bottom: { style: 'thin' },
								right: { style: 'thin' },
							},
							listType: {
								hasCountry: true,
								hasNationality: true,
							},
							})
							setOpenDialog(false)
						},
						variant: 'contained',
						color: 'primary',
						},
					},
					],
				},
				}}
			/> */}





			<FloatButton
				onClick={() =>
					history.push(
						`/menu/outlet-app/outlet-setting/${outletID}/menu-item/add`,
					)
				}
			/>

			<CommonDialogV2
				fullWidth
				open={openStatusDialog}
				onClose={() => setOpenStatusDialog(false)}
				sections={{
					header: {
						dynamic: (
							<div className="">
								<div className="dialog-dynamic-content">
									<div className="session">
										<div className="title color-primary-orange">
											{menu?.obj?.isActive === true ? 'Inactive' : 'Active'}
											{` ${menu?.obj?.name}`}
										</div>
									</div>
								</div>
							</div>
						),
					},
					body: () => (
						<div>
							<span className="mdDesc">
								{menu?.obj?.isActive === true
									? 'Confirm inactive?'
									: 'Confirm activate?'}
							</span>
						</div>
					),
					footer: {
						actions: [
							{
								displayText: 'Cancel',
								props: {
									onClick: () => {
										setOpenStatusDialog(false);
									},
									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Confirm',
								props: {
									onClick: () => {
										setOpenStatusDialog(false);
										submitUpdateStatusMenuItem();
									},
									variant: 'contained',
									color: 'primary',
								},
							},
						],
					},
				}}
			/>
		</>
	);
};
export const extJournalTemplateForm = [
  {
    header: {
      header: 'name',
      width: 17,
    },
  },
   {
    header: {
      header: 'nativeName',
      width: 17,
    },
  },
  {
    header: {
      header: 'kitchenName',
      width: 17,
    },
  },
  {
    header: {
      header: 'description',
      width: 17,
    },
  },
  {
    header: {
      header: 'major',
      width: 17,
    },
  },
  {
    header: {
      header: 'family',
      width: 17,
    },
  },
  {
    header: {
      header: 'kitchenPrinter',
      width: 17,
    },
  },
    {
    header: {
      header: 'taxschemes',
      width: 17,
    },
  },
  {
    header: {
      header: 'uom',
      width: 40,
    },
  },
  {
    header: {
      header: 'defaultQuantity',
      width: 30,
    },
  },
  {
    header: {
      header: 'isOpenItem',
      width: 17,
    },
  },
  {
    header: {
      header: 'isOpenPrice',
      width: 17,
    },
  },
  {
    header: {
      header: 'isChefRecommended',
      width: 40,
    },
  },
  {
    header: {
      header: 'isQuantityControlled',
      width: 15,
    },
    // dataType: 'amount',
  },
  {
    header: {
      header: 'isDiscountable',
      width: 17,
    },
  },
  {
    header: {
      header: 'isByWeight',
      width: 15,
    },
  },
  {
    header: {
      header: 'standardCost',
      width: 15,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'isPerforated',
      width: 15,
    },
  },
  {
    header: {
      header: 'perforatedQuantity',
      width: 15,
    },
  },
]


export const digitalMenuForm=
[
	{
		header: {
			header: 'outletName',
			width: 15,
		},
	},
	{
		header: {
			header: 'Name',
			width: 15,
		},
	},
	{
		header:{
			header:'Description',
			width:15
		}
	},
]

export const digitalMenucategoryForm = [
	{
		header: {
			header: 'digitalMenuName',
			width: 15,
		},
	},
	{
		header: {
			header: 'outletName',
			width: 15,
		},
	},
	{
		header:{
			header:'name',
			width:15
		}
	},
	{
		header:{
			header:'priority',
			width:15
		}
	},
]

export const digitalMenuItemForm = [
	{
		header: {
			header: 'outletName',
			width: 15,
		},
	},
	{
		header: {
			header: 'digitalMenuCatgoryName',
			width: 15,
		},
	},
	{
		header:{
			header:'menuItemName',
			width:15
		}
	},
]

export const digitalMenuItemPriceForm = [
	{
		header: {
			header: 'outletName',
			width: 15,
		},
	},
	{
		header: {
			header: 'digitalMenuItemName',
			width: 15,
		},
	},
	{
		header: {
			header: 'patronType',
			width: 15,
		},
	},
	{
		header:{
			header:'price',
			width:15
		}
	},
]